export default __webpack_public_path__ + "static/media/content_distribution.a228e017.png";